<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-05 16:08:49
 * @Description: 图片组件
-->
<template>
  <el-image :src="src" :fit="fit" :preview-src-list="previewSrcList" @click="handleClick"></el-image>
</template>

<script>
import mixin from './index.js'

export default {
  name: 'LsImage',
  componentName: 'LsImage',
  mixins: [mixin],
  props: {
    src: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'contain'
    },
    previewSrcList: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>